<template>
  <div>
    <v-col class="justify-center" sm="12" md="12" lg="12">
      <v-simple-table class="iol-v2-tor-results">
        <template v-slot:default>
          <thead>
            <tr>
              <th>{{ fields.th1 }}</th>
              <th>{{ fields.th2 }}</th>
              <th>{{ fields.th3 }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ fields.pm1.tor }}</td>
              <td>{{ fields.pm1.cyl }}</td>
              <td>{{ fields.pm1.axis }}</td>
            </tr>
            <tr>
              <td>{{ fields.pm05.tor }}</td>
              <td>{{ fields.pm05.cyl }}</td>
              <td>{{ fields.pm05.axis }}</td>
            </tr>
            <tr>
              <td class="bg-blue">{{ fields.p0.tor }}</td>
              <td class="bg-blue">{{ fields.p0.cyl }}</td>
              <td class="bg-blue">{{ fields.p0.axis }}</td>
            </tr>
            <tr>
              <td>{{ fields.p05.tor }}</td>
              <td>{{ fields.p05.cyl }}</td>
              <td>{{ fields.p05.axis }}</td>
            </tr>
            <tr>
              <td>{{ fields.p1.tor }}</td>
              <td>{{ fields.p1.cyl }}</td>
              <td>{{ fields.p1.axis }}</td>
            </tr>
          </tbody>
          <tfoot v-if="fields.footer != ''">
            <tr>
              <td colspan="3">{{ fields.footer }}</td>
            </tr>
          </tfoot>
        </template>
      </v-simple-table>
    </v-col>
  </div>
</template>

<style>
.iol-v2-tor-results.v-data-table {
  border: 1px solid #000 !important;
  border-radius: 3px !important;
  background-color: inherit !important;
  text-align: center !important;
}
.iol-v2-tor-results.v-data-table thead tr th {
  background-color: #c4c4c4 !important;
  color: #000 !important;
  font-size: 18px !important;
  font-style: bold !important;
  text-align: center !important;
}
.iol-v2-tor-results.v-data-table tr > td:nth-child(2) {
  border-right: 1px solid #000 !important;
  border-left: 1px solid #000 !important;
}
.iol-v2-tor-results.v-data-table th:nth-child(2) {
  border-right: 1px solid #000 !important;
  border-left: 1px solid #000 !important;
}
.iol-v2-tor-results.v-data-table tfoot tr td {
  background-color: #c4c4c4 !important;
  color: #000 !important;
  font-size: 18px !important;
  font-weight: bold !important;
  text-align: center !important;
}
</style>

<script>
export default {
  name: 'iol-result-toric-table',
  props: ['fields'],
  data() {
    return {
      field: this.fields,
    }
  },
  created() {
    this.$emit('fields', this.field)
  },
}
</script>
